import MaterialManagement from "./-materialManagement";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/system/materialManagement")({
  staticData: {
    menuLabel: "素材管理",
    showInMenu: false,
    menuGroup: "/system",
    menuOrder: 2,
  },
  component: MaterialManagement,
});
